import { useEffect, useState } from "react";
import { fetchPaymentDateGroups, downloadGroupsExcel } from "../Api/ViewPaymentDateGroupMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewPaymentDateGroupMaster = () => {
  const [groups, setGroups] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadGroups = async () => {
      try {
        const data = await fetchPaymentDateGroups();
        setGroups(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Payment Date Groups");
      }
    };

    loadGroups();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadGroupsExcel();
      
      // Create a blob from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'PaymentDateGroups.xlsx'); // Set the file name
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();
      
      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success("🦄 Download started successfully!");
    } catch (error) {
      toast.error("🦄 Error downloading payment date groups data");
      console.error("Download error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    
      <div>
        <Container className="list-container">
          <div className="header-background">
            <span className="header-list-title">View Payment Date Groups</span>
            <Button className="gradient-btn"
              variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading || groups.length === 0}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {groups.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Created On</th>
                      <th>Created Time</th>
                      <th>Created By</th>
                      <th>Changed On</th>
                      <th>Changed Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groups.map((group, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{group.code}</td>
                        <td>{group.description}</td>
                        <td>{group.createdOnDate ? moment(group.createdOnDate).format("L") : ""}</td>
                        <td>{group.createdOnTime?.split(".")[0]}</td>
                        <td>{group.createdBy}</td>
                        <td>{group.changedOnDate ? moment(group.changedOnDate).format("L") : "-"}</td>
                        <td>{group.changedOnTime ? group.changedOnTime.split(".")[0] : "-"}</td>
                        <td>{group.changedBy || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No payment date groups found.</p>
          )}
        </Container>
      </div>
   
  );
};

export default ViewPaymentDateGroupMaster;